import {
  GapShorthandValue,
  StyleDefinition,
  ControlService,
} from '../../types';
import { setSpacingValueShape } from '../constants';
import { Padding } from '@wix/document-services-types/src/style/layout';

import {
  getShorthandStyleValues,
  getStyleValue,
} from '../../common/valueResolverService';
import { isPaddingValue } from '../../common/valueResolverService/valueGuards';
import { Length } from '@wix/document-services-types/src/style/dataTypes';
import { getSingleNumericValue } from './readers';
import { StyleVariableValueValue } from '@wix/document-services-types';

function singleValueUpdater(
  value: StyleVariableValueValue | undefined,
  percentage: number,
): Length {
  const currentNumber = getSingleNumericValue(value) ?? 0;
  const newValue = Math.round((percentage * currentNumber) / 100);
  // @ts-expect-error - TODO: ds-types-bump
  return setSpacingValueShape(newValue);
}

function shorthandPaddingUpdater(
  currentValue: Padding,
  updaterFunction: (currentValue: Length) => Length,
): Padding {
  const result = { ...currentValue };
  const paddingProperties: (keyof Omit<Padding, 'type'>)[] = [
    'top',
    'left',
    'right',
    'bottom',
  ];
  for (const property of paddingProperties) {
    const value = currentValue[property];
    // @ts-expect-error - TODO: ds-types-bump
    if (value && value.type === 'Length') {
      // @ts-expect-error - TODO: ds-types-bump
      result[property] = updaterFunction(value);
    }
  }

  return result;
}

function shorthandGapUpdater(
  currentValue: GapShorthandValue,
  updaterFunction: (currentValue: Length) => Length,
): GapShorthandValue {
  // @ts-expect-error - TODO: ds-types-bump
  const result = { ...currentValue };
  const paddingProperties: (keyof Omit<GapShorthandValue, 'type'>)[] = [
    'columnGap',
    'rowGap',
  ];
  for (const property of paddingProperties) {
    const value = currentValue[property];
    // @ts-expect-error - TODO: ds-types-bump
    if (value && value.type === 'Length') {
      result[property] = updaterFunction(value);
    }
  }

  // @ts-expect-error - TODO: ds-types-bump
  return result;
}

function shortHandUpdater(
  currentValue: Padding | GapShorthandValue,
  updaterFunction: (currentValue: Length) => Length,
): Padding | GapShorthandValue {
  // @ts-expect-error - TODO: ds-types-bump
  if (isPaddingValue(currentValue)) {
    return shorthandPaddingUpdater(currentValue, updaterFunction);
  }

  return shorthandGapUpdater(currentValue, updaterFunction);
}

export const updateStylesProportionally = (
  percentage: number,
  styles: ControlService['styles'],
  styleDefinitions: ControlService['styleDefinitions'],
  styleIds: string[],
) => {
  return styleIds.reduce((updatedStyles, styleId) => {
    const valueUpdater = new ValueUpdater(
      styles[styleId],
      styleDefinitions[styleId],
    );
    // @ts-expect-error - TODO: ds-types-bump
    updatedStyles[styleId] = valueUpdater.updateStyleValue(percentage);
    return updatedStyles;
  }, {} as Record<string, StyleVariableValueValue>);
};

export const updateStylesWithSameValue = (
  newValue: number,
  styleIds: string[],
  styles: ControlService['styles'],
  styleDefinitions: ControlService['styleDefinitions'],
) => {
  return styleIds.reduce((updatedStyles, styleId) => {
    const valueUpdater = new ValueUpdater(
      styles[styleId],
      styleDefinitions[styleId],
    );
    // @ts-expect-error - TODO: ds-types-bump
    updatedStyles[styleId] = valueUpdater.setStyleValue(newValue);
    return updatedStyles;
  }, {} as Record<string, StyleVariableValueValue>);
};

class ValueUpdater {
  private shorthandValue?: ReturnType<typeof getShorthandStyleValues>;
  private value?: ReturnType<typeof getStyleValue>;
  constructor(
    styleObject: { value: StyleVariableValueValue } | undefined,
    styleDefinition: StyleDefinition,
  ) {
    this.shorthandValue = getShorthandStyleValues(styleObject, styleDefinition);
    this.value = getStyleValue(styleObject, styleDefinition);
  }

  setStyleValue(newValue: number) {
    if (this.shorthandValue) {
      return shortHandUpdater(this.shorthandValue, () =>
        // @ts-expect-error - TODO: ds-types-bump
        setSpacingValueShape(newValue),
      );
    }
    return setSpacingValueShape(newValue);
  }

  updateStyleValue(percentage: number) {
    if (this.shorthandValue) {
      return shortHandUpdater(this.shorthandValue, (currentLength) =>
        singleValueUpdater(currentLength, percentage),
      );
    }
    return singleValueUpdater(this.value, percentage);
  }
}
